import React from "react";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "@material-ui/core";

import { IExamsTableRowData } from "components/VetExamsTable/types";

import useStyles from "./styles";

interface IProps {
  entries: IExamsTableRowData[];
  trainerName: string;
  renderRows: (requests: IExamsTableRowData[]) => React.ReactElement[];
  hasFixedHeaderCells?: boolean;
}

const TrainerAccordionView = (props: IProps) => {
  const {
    entries,
    trainerName,
    renderRows,
    hasFixedHeaderCells = false
  } = props;

  const [expanded, setExpanded] = React.useState(true);

  const handleChange = () => {
    setExpanded(!expanded);
  };
  const classes = useStyles();

  const renderHeaderFiller = () => (
    <div className={classes.rowMenu}>
      <div className={classes.headerFiller}></div>
    </div>
  );

  return (
    <Accordion expanded={expanded} onChange={handleChange}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
        classes={{
          expandIcon: classes.expandIconTrainer,
          content: classes.summaryContent,
          root: classes.summaryRoot
        }}
        className={classes.header}
      >
        {trainerName}
        {hasFixedHeaderCells && renderHeaderFiller()}
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        {renderRows(entries)}
      </AccordionDetails>
    </Accordion>
  );
};

export default TrainerAccordionView;
